import React, { useState, useEffect, useRef } from 'react';

const SentenceInput = props => {
  const { value, onChange } = props;
  const inputRef = useRef(null);
  useEffect(() => {
    const input = inputRef.current;
    input.style.width = 'auto';
    input.style.width = `${input.scrollWidth}px`;
  });
  return (
    <>
      <input
        className="category_tile"
        ref={inputRef}
        type="text"
        value={value}
        onChange={onChange}
        placeholder="Ecrire le nom de la catégorie"
        disabled={props?.disabled}
      />
    </>
  );
};

export default SentenceInput;
